<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Promo</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PROMO</h6>
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Nama Promo">
                                <b-form-input v-model="input.namaPromo" name="namaPromo" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-group>
                                <label class="radio-label">
                                    <b-form-radio v-model="input.detailInfo" value="persen">Persen</b-form-radio>
                                </label>
                                <b-input-group append="%">
                                    <b-form-input v-model="input.nominalPersen" id="persenDesc" name="inputNominalPersen" step="0.01" type="number" @blur="roundPersen" :disabled="input.detailInfo == 'nominal'" required></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-popover target="persenDesc" title="Catatan" triggers="focus">
                                <ul class="tooltip-content-wrapper list-popover-wrapper">
                                    <li class="mb-2">
                                        <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                                    </li>
                                    <li class="mb-2">
                                        <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                                    </li>
                                    <li class="mb-0">
                                        <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                                    </li>
                                </ul>
                            </b-popover>
                        </b-col>
                        <b-col md="4">
                            <b-form-group>
                                <label class="radio-label">
                                    <b-form-radio v-model="input.detailInfo" value="nominal">Nominal</b-form-radio>
                                </label>
                                <b-input-group prepend="Rp.">
                                    <b-form-input v-model="input.nominalAngka" name="inputNominalAngka" :disabled="input.detailInfo == 'persen'" required></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Minimal Harga Barang">
                                <b-input-group prepend="Rp.">
                                    <b-form-input v-model="input.hargaBarangMinimal" name="inputHargaBarangMinimal" required></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Maksimal Harga Barang">
                                <b-input-group prepend="Rp.">
                                    <b-form-input v-model="input.hargaBarangMaksimal" name="inputHargaBarangMaksimal" required></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4" >
                            <b-form-group label="Tipe Pinjaman">
                                <b-form-select v-model="input.tipePinjaman" name="tipePinjaman" 
                                :options="optionTipePinjaman" value-field="id" text-field="name" required>
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Jenis Barang">
                                <multiselect name="jenisBarang"
                                    :value="optionJenisBarang.find(item => item.id == input.jenisBarang) || null"
                                    :options="optionJenisBarang" :internal-search="true" :allow-empty="true"
                                    :disabled="optionJenisBarang.length == 0" deselect-label=""
                                    select-label="" label="name" track-by="id"
                                    placeholder="Semua Jenis Barang"
                                    @input="input.jenisBarang = $event ? $event.id : null" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        
                        <b-col md="4">
                            <b-form-group label="Merk Barang">
                                <multiselect name="merkBarang"
                                    :value="optionMerkBarang.find(item => item.id == input.merkBarang) || null"
                                    :options="optionMerkBarang" :internal-search="true" :allow-empty="true"
                                    :disabled="optionMerkBarang.length == 0" deselect-label=""
                                    select-label="" label="name" track-by="id"
                                    placeholder="Semua Merk Barang"
                                    @input="input.merkBarang = $event ? $event.id : null" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Tipe Barang">
                                <multiselect name="tipeBarang"
                                    :value="optionTipeBarang.find(item => item.id == input.tipeBarang) || null"
                                    :options="optionTipeBarang" :internal-search="true" :allow-empty="true"
                                    :disabled="optionTipeBarang.length == 0" deselect-label=""
                                    select-label="" label="name" track-by="id"
                                    placeholder="Semua Tipe Barang"
                                    @input="input.tipeBarang = $event ? $event.id : null" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Tanggal Mulai Promo">
                                <b-form-input v-model="input.mulaiPromo" name="mulaiPromo" type="date" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Tanggal Selesai Promo">
                                <b-form-input v-model="input.selesaiPromo" name="selesaiPromo" type="date" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Keterangan">
                                <b-form-textarea v-model="input.keterangan" name="keterangan" rows="3" required></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper">
                    <h6 class="form-title">CABANG</h6>
                    <b-form-group>
                        <b-form-checkbox
                            v-model="checkAllCabang" name="checkAllCabang"
                            :disabled="disabled"
                            @change="toggleAll"
                            >
                            {{ checkAllCabang ? 'Uncheck All' : 'Check All' }}
                        </b-form-checkbox>
                    </b-form-group>
                    <div>
                        <div class="search-wrapper d-flex align-items-center justify-content-between">
                            <b-form-group
                                label="Filter"
                                label-for="filterInput"
                                class="form-inline mb-3"
                            >
                                <b-form-input class="mr-2 ml-2"
                                v-model="filterCabang" name="filterTable"
                                type="search"
                                placeholder="Type to search"
                                ></b-form-input>
                            </b-form-group>
                        </div>
                        <b-table bordered hover show-empty
                            :busy="isBusy"
                            :items="cabangItems" 
                            :fields="fields"
                            :currentPage="currentPage" 
                            :perPage="perPage"
                            :filter="filterCabang"
							:filterIncludedFields="filterOn"
                            @filtered="onFiltered"
                            responsive class="mb-3">
                            <template v-slot:cell(checkCabang)="row">
                                <b-form-checkbox :id="'cb' + row.item.id" v-model="row.item.selected">
                                    {{ row.item.name }}
                                </b-form-checkbox>
                            </template>
                            <template v-slot:empty>
                                Tidak ada data cabang.
                            </template>
                        </b-table>
                        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                            <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                                <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null" disabled />
                                    </template>
                                </b-form-select>
                                <span class="ml-2">{{ totalViewText }}</span>
                            </b-input-group>
                            <b-pagination class="mb-0"
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                                aria-controls="my-table"
                                @input="onPageChange"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="promoSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Promo" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput promo ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-promo',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input: {
                namaPromo: "",
                tipePinjaman: null,
                jenisBarang: null,
                merkBarang: null,
                tipeBarang: null,
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaBarangMinimal: null,
                hargaBarangMaksimal: null,
                keterangan: "",
                mulaiPromo: "",
                selesaiPromo: "",
                show: 10
            },
            fields: [
                { key: "checkCabang", label: "Cabang", tdClass: "checkboxCabang" },
            ],
            filterCabang: null,
			filterOn: ["name"],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            checkAllCabang: false,
            disabled: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            
            cabangItems: [],
            optionTipePinjaman: [],
            optionJenisBarang: [],
            optionMerkBarang: [],
            optionTipeBarang: [],
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show

            let getTipePinjaman = this.$axios.get('jenis-pinjaman/').then(response => {
                this.optionTipePinjaman = response.data
            })

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                this.cabangItems = response.data.map(item => { return { id: item.id, name: item.name, selected: false } })
                this.updateTotalItem()
            })

            Promise.all([getTipePinjaman, getCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.toggleBusy()
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let limit = null
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
        },

        onLimitChange(){
            if(this.input.show == 'All'){
                this.perPage = this.rows
            }else{
                this.perPage = this.input.show
                this.onPageChange()
            }
            
        },
        
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            let nominal = this.$helper.removeThousandSeparator(this.input.nominalAngka)
            let minimal = this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal)
            let maksimal = this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal)
            let cabang = []

            //----------------- Append Data Promo -----------------

            payload.append("name", this.input.namaPromo)
            payload.append("jenisPinjamanId", this.input.tipePinjaman)
            payload.append("keterangan", this.input.keterangan)
            payload.append("start", this.input.mulaiPromo)
            payload.append("end", this.input.selesaiPromo)
            payload.append("hargaBarangMinimal", minimal)
            payload.append("hargaBarangMaksimal", maksimal)
            
            if (this.input.detailInfo == "nominal") payload.append("nominal", nominal)
            else payload.append("persen", this.input.nominalPersen)

            let y = 0
            for (var x of selectedCabang) {
                cabang[y] = x.id
                y++
            }

            payload.append("cabangId", cabang)
            
            if (this.input.jenisBarang != null) {
                payload.append("jenisBarangId", this.input.jenisBarang)
            }
            if (this.input.merkBarang != null) {
                payload.append("merkBarangId", this.input.merkBarang)
            }
            if (this.input.tipeBarang != null) {
                payload.append("tipeBarangId", this.input.tipeBarang)
            }
            

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("promo/", payload).then(response => {
                this.$helper.setFlash("Promo baru telah berhasil dibuat!")
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
            
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toggleAll(checked) {
            for(let i=0; i< this.cabangItems.length; i++){
                this.cabangItems[i].selected = checked
            }
        },

        updateTotalItem(){
            this.rows = this.cabangItems.length
            if (this.perPage > this.rows) this.perPage = this.rows
        },


        openModalConfirm(){
            let selectedCabang = this.cabangItems.filter(item => item.selected)
            
            if (selectedCabang.length == 0) {
                this.$helper.toastErr(this, "Mohon memilih minimal 1 cabang!")
            }
            else if (this.input.mulaiPromo > this.input.selesaiPromo) {
                this.$helper.toastErr(this, "Tanggal mulai harus sebelum tanggal selesai!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) < 0 || this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal) < 0) {
                this.$helper.toastErr(this, "Minimal dan maksimal harga barang tidak boleh negatif!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) > this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal)) {
                this.$helper.toastErr(this, "Minimal harga barang tidak boleh melebihi maksimal harga barang")
            }
            else {
                this.$bvModal.show("modal-confirm-input")
            }
        },

        roundPersen(){
            var x = Number(this.input.nominalPersen).toFixed(2);
            this.input.nominalPersen = x;
        }
    },

    watch: {
        "input.nominalAngka": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalAngka = result);
        },

        "input.hargaBarangMinimal": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaBarangMinimal = result);
        },

        "input.hargaBarangMaksimal": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaBarangMaksimal = result);
        },

        'input.tipePinjaman': function(newVal) {
            
            this.optionJenisBarang = []
            this.input.jenisBarang = null

            this.optionMerkBarang = []
            this.input.merkBarang = null

            this.optionTipeBarang = []
            this.input.tipeBarang = null
            
            if (newVal == null) { return }

            const tipePinjaman = this.optionTipePinjaman.find(item => item.id == newVal)
            if (tipePinjaman == null) return
            const endpoint = tipePinjaman.name.toLowerCase()

            this.$axios.get(`barang-jenis/${endpoint}`).then(response => {
                this.optionJenisBarang = response.data
            })
        },

        'input.jenisBarang': function(newVal) {
            
            this.optionMerkBarang = []
            this.input.merkBarang = null

            this.optionTipeBarang = []
            this.input.tipeBarang = null
            
            if (newVal == null) { return }

            this.$axios.get(`barang-merk/jenis/${newVal}`).then(response => {

                this.optionMerkBarang = response.data

            })
        },

        'input.merkBarang': function(newVal) {
            
            this.optionTipeBarang = []
            this.input.tipeBarang = null
            
            if (newVal == null) { return }

            this.$axios.get(`barang-tipe-v2/merk/${newVal}`).then(response => {

                this.optionTipeBarang = response.data.types

            })
        },
    },
    created(){
        this.init()
    }
}
</script>
